module.exports = __webpack_public_path__ + "fonts/ComicNeueSansID.13a5dec4.woff";